







































import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import PersistSkill from '@/domain/drd-2.0/entity/persist-skill.entity'
import SkillService from '@/domain/drd-2.0/service/skill.service';
import Skill from '@/domain/drd-2.0/entity/skill.entity';
import FormSkillComponent from '../form/form-skill.component.vue'

@Component({
  components: {
    LabelSlot,
    FormSkillComponent,
  },
})
export default class CreateSkillModal extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) open!: boolean;

  @Prop({
    type: Object,
    default: null,
  }) initialValue?: PersistSkill;

  skill: PersistSkill = new PersistSkill();

  loading: boolean = false;

  mounted() {
    if (this.initialValue) {
      this.skill = new PersistSkill({ ...this.initialValue });
    }
  }

  save() {
    const { formComponent } = this.$refs as any;
    const { form } = formComponent.$refs;
    if (!form.validate()) return;
    this.loading = true;
    SkillService.create(this.skill)
      .then(({ data }: any) => {
        VbSnackbarService.showSuccess('Competência criada com sucesso!');
        this.saved(data);
      })
      .catch((error) => {
        VbSnackbarService.showError(error.response.data.messages.toString());
      })
      .finally(() => this.loading = false);
  }

  saved(skill: Skill) {
    this.$emit('saved', skill);
  }

  closeModal() {
    this.skill = new PersistSkill();
    this.$emit('close');
  }

  update(event: any) {
    this.skill[event.field] = event.value;
  }
}
